export const uniqueness = (value, index, array) => {
  return array.indexOf(value) === index;
};
